{
  "title": "Celery",
  "stats": {
    "total": "Total",
    "active": "Active",
    "processed": "Processed",
    "tasksInQueue": "Tasks in queue",
    "retried": "Retried"
  },
  "states": {
    "all": "All",
    "active": "Active",
    "success": "Successful",
    "failed": "Failed"
  },
  "workers": {
    "title": "Workers",
    "name": "Name",
    "status": "State",
    "processes": "Processes",
    "pending": "Pending",
    "active": "Active",
    "processed": "Processed",
    "success": "Successful",
    "failure": "With errors",
    "retry": "Retried",
    "clearQueue": "Clear queue",
    "killActiveTasks": "Kill active tasks",
    "queues": "Queues",
    "all": "All"
  },
  "tasks": {
    "title": "Tasks",
    "name": "Name",
    "state": "State",
    "received": "Received at",
    "started": "Started at",
    "runtime": "Duration",
    "killTask": "Kill task"
  },
  "queues": {
    "name": "Name",
    "state": "State",
    "ready": "Ready",
    "unacknowledged": "Unacknowledged",
    "total": "Total",
    "clearQueue": "Clear queue"
  }
}